import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKazakhstan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_55)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7826 12.1304H5.21738C5.21738 13.067 6.03305 13.8261 6.96947 13.8261H6.91303C6.91303 14.7626 7.67217 15.5218 8.60869 15.5218C8.60869 16.4583 9.36783 17.2174 10.3043 17.2174H13.6957C14.6322 17.2174 15.3913 16.4583 15.3913 15.5218C16.3278 15.5218 17.087 14.7626 17.087 13.8261H17.0305C17.9668 13.8261 18.7826 13.067 18.7826 12.1304Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.6957 9.91302C16.6957 12.5063 14.5933 14.6087 12 14.6087C9.40665 14.6087 7.30435 12.5063 7.30435 9.91302",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5866 9.91304L14.1211 10.6024L14.9015 12.0218L13.3101 11.7173L13.1085 13.325L12 12.1426L10.8915 13.325L10.6899 11.7173L9.09849 12.0217L9.87886 10.6024L8.41336 9.91304L9.87891 9.22369L9.09849 7.80436L10.6898 8.10877L10.8915 6.50114L12 7.68357L13.1085 6.50114L13.3101 8.10877L14.9016 7.80436L14.1211 9.22374L15.5866 9.91304Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_55",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgKazakhstan;
